import React, {useRef, useEffect} from 'react';
import PropTypes from 'prop-types';

export function AnimatedCanvas(props) {
    const canvasRef = useRef(null);
    const {onAnimation, ...otherProps} = props;

    useEffect(() => {
        let raf;

        function animate(timestamp) {
            onAnimation(canvasRef.current.getContext('2d'), timestamp);
            raf = requestAnimationFrame(animate);
        }

        raf = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(raf);
    }, [canvasRef, onAnimation, props]);

    return <canvas {...otherProps} ref={canvasRef} />;
}

AnimatedCanvas.propTypes = {
    onAnimation: PropTypes.func.isRequired,
};
